import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

import AccessControl from 'app/auth/AccessControl'
import { ReactComponent as EmptyTeamMemberIcon } from 'app/components/icons/empty-team-member-icon.svg'

const EmptyState = (props) => {
  const {
    icon = undefined,
    title,
    description,
    accesses,
    onAction,
    isStyle = true,
  } = props

  return (
    <div
      style={
        isStyle
          ? {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }
          : {}
      }
    >
      <div className="flex justify-center">
        {icon ?? <EmptyTeamMemberIcon />}
      </div>
      <div className="text-16 font-bold text-primary my-5 flex justify-center">
        {title}
      </div>
      <div className="text-primary my-2 flex justify-center text-center w-1/2 mx-auto">
        {description}
      </div>
      <AccessControl accesses={accesses}>
        <div className="flex justify-center my-10">{onAction}</div>
      </AccessControl>
    </div>
  )
}

EmptyState.propTypes = {
  icon: PropTypes.node,
  isStyle: PropTypes.bool,
  title: PropTypes.string,
  onAction: PropTypes.node,
  accesses: PropTypes.array,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default EmptyState
